import React from 'react';
import { oneOfType, array, object } from 'prop-types';
import { get, map, toString } from 'lodash';
import { Text, FlexContainer, Row, CounterButton } from '../../common';

const HorizontalCounters = ({ data }) => {
    const items = [
        { label: 'Total con error', key: 'errors' },
        { label: 'Total facturados', key: 'total' }
    ];

    return (
        <FlexContainer>
            { map(items, ({ label, key }, index) => {
                const isTotal = key === 'total';
                return (
                    <Row noWrap align='center'>
                        <Text
                            text={label}
                            nowrap
                            strong={isTotal}
                        />
                        <CounterButton
                            marginHorizontal={10}
                            noHover
                            backgroundColor={!isTotal ? '#cc444b' : '#f4f4f4'}
                        >
                            <Row justify='center' align='center' margin={2}>
                                <Text
                                    text={toString(get(data, key, 0))}
                                    strong
                                    color={!isTotal ? '#ffffff' : '#333333'}
                                />
                            </Row>
                        </CounterButton>
                    </Row>
                );
            }) }
        </FlexContainer>
    );
};

HorizontalCounters.propTypes = {
    data: oneOfType([array, object])
};

HorizontalCounters.defaultProps = {
    data: {}
};

export default HorizontalCounters;
